import React, { useState, useEffect } from 'react';

export default function TestimonialSlider({ testimonials = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const hasTestimonials = testimonials && testimonials.length > 0;
  const count = hasTestimonials ? testimonials.length : 0;

  const handleNext = () => {
    if (count > 0) {
      setCurrentIndex((prev) => (prev + 1) % count);
    }
  };

  const handlePrev = () => {
    if (count > 0) {
      setCurrentIndex((prev) => (prev - 1 + count) % count);
    }
  };

  // Autoplay slider every 6s
  useEffect(() => {
    if (count === 0) return;
    const timer = setInterval(() => {
      if (count > 0) {
        setCurrentIndex((prev) => (prev + 1) % count);
      }
    }, 6000);
    return () => clearInterval(timer);
  }, [count]);

  if (!hasTestimonials) return null;

  return (
    <div className="relative">
      {/* Cards Container */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 3 }).map((_, colIdx) => {
          const itemIndex = (currentIndex + colIdx) % count;
          const review = testimonials[itemIndex];
          if (!review) return null;

          return (
            <div
              key={`${itemIndex}-${colIdx}`}
              className={`bg-[#FAF7F2] p-8 rounded-3xl border border-[#E8DFD5] flex flex-col justify-between space-y-6 shadow-xs ${
                colIdx === 1 ? 'hidden md:flex' : ''
              } ${colIdx === 2 ? 'hidden lg:flex' : ''}`}
            >
              <div className="space-y-4">
                {/* Stars */}
                <div className="flex items-center space-x-1 text-[#D8ADA0]">
                  {Array.from({ length: review.stjerner || 5 }).map((_, i) => (
                    <i key={i} className="fa-solid fa-star text-sm" aria-hidden="true" />
                  ))}
                </div>

                {/* Quote */}
                <p className="text-[#2E2A27] italic text-base leading-relaxed font-sans">
                  "{review.citat}"
                </p>
              </div>

              {/* Client Info */}
              <div className="flex items-center gap-4 pt-4 border-t border-[#E8DFD5]">
                {review.billede && review.billede.length > 0 ? (
                  <img
                    src={`https://assets.auxodev.dk/cdn-cgi/image/width=150,height=150,fit=cover,format=auto/${review.billede[0].replace('https://assets.auxodev.dk/', '')}`}
                    alt={review.navn}
                    className="w-12 h-12 rounded-full object-cover border-2 border-[#98866C]/40"
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-[#98866C]/20 text-[#2E2A27] font-serif font-bold flex items-center justify-center text-lg">
                    {review.navn ? review.navn[0] : 'Z'}
                  </div>
                )}
                <div>
                  <span className="font-serif font-semibold text-[#2E2A27] text-lg block leading-tight">
                    {review.navn}
                  </span>
                  <span className="text-xs text-[#2E2A27]/80 font-medium block mt-0.5">
                    {review.rolle}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Slider Nav Buttons */}
      <div className="flex items-center justify-center space-x-4 mt-8">
        <button
          type="button"
          onClick={handlePrev}
          className="w-11 h-11 rounded-full bg-white border border-[#E8DFD5] text-[#2E2A27] hover:bg-[#98866C] hover:border-[#98866C] hover:text-white transition-all duration-200 flex items-center justify-center shadow-xs cursor-pointer"
          aria-label="Forrige udtalelse"
        >
          <i className="fa-solid fa-chevron-left" aria-hidden="true" />
        </button>

        {/* Indicators */}
        <div className="flex items-center space-x-2">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => setCurrentIndex(idx)}
              className={`h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                idx === currentIndex ? 'w-8 bg-[#98866C]' : 'w-2.5 bg-[#D8CDBF]'
              }`}
              aria-label={`Gå til udtalelse ${idx + 1}`}
            />
          ))}
        </div>

        <button
          type="button"
          onClick={handleNext}
          className="w-11 h-11 rounded-full bg-white border border-[#E8DFD5] text-[#2E2A27] hover:bg-[#98866C] hover:border-[#98866C] hover:text-white transition-all duration-200 flex items-center justify-center shadow-xs cursor-pointer"
          aria-label="Næste udtalelse"
        >
          <i className="fa-solid fa-chevron-right" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
